class CatalogSource {
    constructor(API) {
        this.API = API;
    }

    async list(data) {
        return await this.API.get('/index.php?route=api/catalog', {
            params: data
        })
    }

    async popular_list(data) {
        return await this.API.get('/index.php?route=api/catalog/popular', {
            params: data
        })
    }
    async recomended() {
        return await this.API.get('/index.php?route=api/catalog/recomended')
    }

    async getProductById(product_id) {
        return await this.API.get('/index.php?route=api/catalog/product', {
            params: {
                product_id: product_id
            }
        })
    }

    async getProductBySlug(slug) {
        return await this.API.get('/index.php?route=api/catalog/product_slug', {
            params: {
                slug: slug
            }
        })
    }

}


export default CatalogSource
